'use strict';

var analyticsHelper = require('app_honda_cars/utils/analyticsHelper');
var configuratorHelpers = require('./configuratorHelpers');

// ─── Helpers ──────────────────────────────────────────────────────────────────

function getBrochureGroupAndCategory() {
    return {
        bGroup: (window._brochureSource === 'configurator') ? 'download_brochure' : 'sidenav_brochure',
        bCategory: (window._brochureSource === 'configurator') ? 'configurator' : 'side navigation'
    };
}

var SIDEBAR_BROCHURE_TIMER_KEY = 'sidebarBrochure';

function buildSelectedModels() {
    var selectedModels = [];
    var $modal = $('#sidebarBrochure');
    var $form = $('#brochure-details-form');
    var carData = $modal.find('.car-data-object').data('cardata') || [];
    $modal.find('.car-card.is-selected').each(function (index) {
        var selectedCarName = $(this).data('productname');
        var selectedCar = carData.find(function (p) { return p.productName === selectedCarName; });
        if (!selectedCar) return;
        var selectedModel = {
            segments: selectedCar.segment || '',
            displayTitle: selectedCar.productName || '',
            title: selectedCar.productName || '',
            code: selectedCar.code || '',
            sf_model: selectedCar.Model || '',
            sf_grade: selectedCar.grade || '',
            sf_door: selectedCar.Door || '',
            sf_year: selectedCar.sfYear || '',
            year: selectedCar.Year || '',
            variants: []
        };
        var selectedVariantCode = $form.find('input[name="car-selected-radio-' + (index + 1) + '"]:checked').val();
        var selectedVariant = (selectedCar.gradeArray || []).find(function (v) { return v.id === selectedVariantCode; });
        if (selectedVariant) {
            selectedModel.variants.push({
                title: selectedVariant.displayValue || '',
                code: selectedVariant.code || '',
                isDefaultVariant: false,
                transmission: selectedCar.trans || '',
                sfGrade: selectedVariant.id || '',
                sfDoor: selectedCar.Door || ''
            });
        }
        selectedModels.push(selectedModel);
    });
    return selectedModels;
}

// ─── Redesign flyout brochure helpers ───────────────────────────────────────────
// Read fresh on every push so the payload follows the user's live selection
// (Honda Centre changes via `amb:showroom-locator:showroom-changed`, Grade changes in-form).

// `form_start` guard for the flyout funnel. In-memory (module-scoped) on purpose:
//   • once per active form   → set true on first interaction, gate `start` on it
//   • re-arm on page reload   → fresh page load re-initialises this to false (free)
//   • re-arm on submit success → reset to false in configuratorBrochureFormComplete
// NOT reset when the view re-opens (e.g. returning from the Honda Centre picker),
// so re-showing the same form does not fire a second `start`.
var hasFlyoutBrochureStarted = false;

// `form_view` guard for the flyout funnel. Same in-memory lifecycle as the `start`
// flag above:
//   • once per active form   → set true on the first view, gate `view` on it
//   • re-arm on page reload   → fresh page load re-initialises this to false (free)
//   • re-arm on submit success → reset to false in configuratorBrochureFormComplete
// NOT reset on view re-entry (click-back, or returning from the Honda Centre picker),
// so re-showing the same form does not fire a second `view`.
var hasFlyoutBrochureViewed = false;

// Current "Your selected Honda Centre" from the flyout form. `.selected-honda-centre` is kept
// in sync by selectedHondaCentre.js and is the same source viewBrochure.js#buildPayload sends.
function getBrochureCentre() {
    var $centre = $('#view-brochure-form .selected-honda-centre').first();
    return {
        dealer: $centre.find('.name').text().trim(),
        location: $centre.find('.address').text().trim(),
        postcode: $centre.find('input[name="AddressPostcode"]').val() || ''
    };
}

// `data` object shared by all four brochure funnel steps. `extra` fills optIn/timeframe on complete.
function buildBrochureData(extra) {
    var centre = getBrochureCentre();
    // configurator.js seeds window.globalSaveuniqueCode = {} (truthy); only accept a real string code.
    var configuratorId = (typeof window.globalSaveuniqueCode === 'string') ? window.globalSaveuniqueCode : '';
    return $.extend({
        'configurator ID': configuratorId,
        'location': centre.location,
        'postcode': centre.postcode,
        'dealer': centre.dealer,
        'optIn': null,
        'timeframe': ''
    }, extra || {});
}

// Base model from the configured variant (main page summary); grade overridden by the in-form
// `#view-brochure-grade` select so `models` matches the lead payload.
function buildBrochureModels() {
    try {
        var productData = JSON.parse($('.js-save-summary').attr('data-car-summary-data')).data.product;
        var model = configuratorHelpers.buildConfiguratorSelectedModel(productData, []);
        var grade = $('#view-brochure-grade option:selected').val();
        if (grade && model.variants && model.variants[0]) {
            model.sf_grade = grade;
            model.variants[0].sfGrade = grade;
        }
        return [model];
    } catch (e) {
        return [];
    }
}

// ─── Event Handlers ───────────────────────────────────────────────────────────

var events = {

    sidebarDownloadBrochure: function (data) {
        window._brochureSource = 'sidebar';
        window.sidenavBrochureUUID = crypto.randomUUID();
        var brochureUUID = window.sidenavBrochureUUID;
        analyticsHelper.timeStart(SIDEBAR_BROCHURE_TIMER_KEY);

        dataLayer.push({ 'event': 'custom.menu', 'group': 'side navigation menu', 'category': 'side navigation', 'action': 'click', 'label': data.text().trim() });

        var inputLocation = document.getElementById('sidebar-edit-location-summary')
            ? document.getElementById('sidebar-edit-location-summary').textContent.trim() : '';
        var locationParts = inputLocation.match(/^(.*)\s(\d{4,5})$/);
        var formattedAddress = locationParts ? locationParts[1] : inputLocation;
        var postalCode = locationParts ? locationParts[2] : '';

        dataLayer.push({
            'event': 'custom.form',
            'group': 'sidenav_brochure',
            'category': 'side navigation',
            'action': 'view',
            'userRequestId': brochureUUID,
            'data': { 'value': 'undefined', 'optIn': null, 'location': formattedAddress, 'postcode': postalCode, 'timeframe': '', 'dealer': '' },
            'models': []
        });

        $('#brochure-details-form').off('change.p2Brochure').on('change.p2Brochure', 'input, select, textarea', function () {
            var selectedModels = buildSelectedModels();
            if (analyticsHelper.isFirstFormInteraction('p2_brochure_sidebar')) {
                dataLayer.push({
                    event: 'custom.form',
                    group: 'sidenav_brochure',
                    category: 'side navigation',
                    action: 'start',
                    userRequestId: window.sidenavBrochureUUID || brochureUUID,
                    data: { 'value': 'undefined', 'optIn': null, 'location': formattedAddress, 'postcode': postalCode, 'timeframe': '', 'dealer': '' },
                    models: selectedModels
                });
            }
            var fieldName = $(this).attr('name') || $(this).attr('id') || '';
            dataLayer.push({
                event: 'custom.form',
                group: 'sidenav_brochure',
                category: 'side navigation',
                action: 'interaction',
                field_name: fieldName,
                field_value: analyticsHelper.getPIISafeValue(fieldName, $(this).val()),
                userRequestId: window.sidenavBrochureUUID || brochureUUID,
                data: { 'value': 'undefined', 'optIn': null, 'location': formattedAddress, 'postcode': postalCode, 'timeframe': '', 'dealer': '' },
                models: selectedModels
            });
        });
    },

    sidebarSelectAModel: function (data) {
        var gc = getBrochureGroupAndCategory();
        var inputLocation = document.getElementById('sidebar-edit-location-summary')
            ? document.getElementById('sidebar-edit-location-summary').textContent.trim() : '';
        var locationParts = inputLocation.match(/^(.*)\s(\d{4,5})$/);
        var formattedAddress = locationParts ? locationParts[1] : inputLocation;
        var postalCode = locationParts ? locationParts[2] : '';
        var selectedModels = buildSelectedModels();
        dataLayer.push({
            'event': 'custom.form',
            'group': gc.bGroup,
            'category': gc.bCategory,
            'action': 'start',
            'data': { 'value': 'undefined', 'optIn': null, 'location': formattedAddress, 'postcode': postalCode, 'timeframe': '', 'dealer': '' },
            'models': selectedModels
        });
    },

    sidebarSelectedModel: function (data) {
    },

    submitUserDetails: function (data) {
    },

    // Fires the sidebar form complete step. Bridged from sidebar.js on
    // `download.brochure.afterLead.success` (data = $form), so it only runs once the lead is accepted.
    downloadBrochure: function (data) {
        var $form = (data && data.length) ? data : $('#brochure-details-form');
        var uuid = window.sidenavBrochureUUID || crypto.randomUUID();
        var dealerName = $form.find('input[name="user-location-dealers"]:checked').data('dealername') || '';
        var consentValue = $form.find('#brochure-when-consent').is(':checked');
        var inputLocation = document.getElementById('sidebar-edit-location-summary')
            ? document.getElementById('sidebar-edit-location-summary').textContent.trim() : '';
        var locationParts = inputLocation.match(/^(.*)\s(\d{4,5})$/);
        var formattedAddress = locationParts ? locationParts[1] : inputLocation;
        var postalCode = locationParts ? locationParts[2] : '';
        var selectedModels = buildSelectedModels();
        var timeSpent = analyticsHelper.timeEnd(SIDEBAR_BROCHURE_TIMER_KEY);

        // Snapshot taken above; mint the next funnel id now so "Download another brochure" is distinct.
        window.sidenavBrochureUUID = crypto.randomUUID();
        analyticsHelper.timeStart(SIDEBAR_BROCHURE_TIMER_KEY);

        analyticsHelper.hashUserData(analyticsHelper.extractFormPII($form)).then(function (userData) {
            dataLayer.push({
                'event': 'custom.form',
                'group': 'sidenav_brochure',
                'category': 'side navigation',
                'action': 'complete',
                'event_id': uuid,
                'userRequestId': uuid,
                'timeSpent': timeSpent,
                'userData': userData,
                'data': {
                    'configurator ID': '',
                    'location': formattedAddress,
                    'postcode': postalCode,
                    'dealer': dealerName,
                    'optIn': consentValue,
                    'insuranceopIn': false,
                    'financeopIn': false
                },
                'models': selectedModels
            });
        });
    },

    // ─── Redesign flyout brochure (configurator "view-brochure" view) ───────────
    // Fires the form_view step + wires start/interaction on #view-brochure-form.
    // Triggered from datalayer.js on `amb:modal-view-changed` (view === 'view-brochure').
    configuratorViewBrochureForm: function () {
        window._brochureSource = 'configurator';
        window.sidenavBrochureUUID = window.sidenavBrochureUUID || crypto.randomUUID();

        // Bind the interaction handler on every entry (idempotent off/on) so start/interaction
        // keep working after view re-entries or a form DOM re-render.
        // Rebuild data/models fresh on every change so Honda Centre / Grade edits are reflected.
        $('#view-brochure-form').off('change.p2ConfigBrochureFlyout').on('change.p2ConfigBrochureFlyout', 'input, select, textarea', function () {
            if (!hasFlyoutBrochureStarted) {
                hasFlyoutBrochureStarted = true;
                dataLayer.push({
                    event: 'custom.form',
                    group: 'brochure_download',
                    category: 'configurator',
                    action: 'start',
                    userRequestId: window.sidenavBrochureUUID || null,
                    data: buildBrochureData(),
                    models: buildBrochureModels()
                });
            }
            var fieldName = $(this).attr('name') || $(this).attr('id') || '';
            dataLayer.push({
                event: 'custom.form',
                group: 'brochure_download',
                category: 'configurator',
                action: 'interaction',
                field_name: fieldName,
                field_value: analyticsHelper.getPIISafeValue(fieldName, $(this).val()),
                userRequestId: window.sidenavBrochureUUID || null,
                data: buildBrochureData(),
                models: buildBrochureModels()
            });
        });

        // Only the FIRST view of a form session fires `view` + starts the funnel timer.
        // Re-entries (click-back, returning from the Honda Centre picker) are skipped here.
        // Re-arms only on submit-complete (see configuratorBrochureFormComplete) or reload.
        if (hasFlyoutBrochureViewed) {
            return;
        }
        hasFlyoutBrochureViewed = true;
        analyticsHelper.timeStart('configuratorBrochure');

        dataLayer.push({
            'event': 'custom.form',
            'group': 'brochure_download',
            'category': 'configurator',
            'action': 'view',
            'userRequestId': window.sidenavBrochureUUID,
            'data': buildBrochureData(),
            'models': buildBrochureModels()
        });
    },

    // Fires the form complete step. Bridged from viewBrochure.js#onSuccess (data = $form).
    configuratorBrochureFormComplete: function (data) {
        var $form = data;
        var optIn = $form.find('[name="PrivacyConsent"]').is(':checked');
        var timeframe = $form.find('#view-brochure-when option:selected').text().trim();
        var models = buildBrochureModels();

        analyticsHelper.hashUserData(analyticsHelper.extractFormPII($form)).then(function (userData) {
            dataLayer.push({
                'event': 'custom.form',
                'group': 'brochure_download',
                'category': 'configurator',
                'action': 'complete',
                'userRequestId': window.sidenavBrochureUUID || null,
                'timeSpent': analyticsHelper.timeEnd('configuratorBrochure'),
                'userData': userData,
                'data': buildBrochureData({ 'optIn': optIn, 'timeframe': timeframe }),
                'models': models
            });

            // allow `form_view` + `form_start` to fire again, and mint a fresh userRequestId
            // so the next view/start/interaction/complete is a distinct funnel from this one.
            hasFlyoutBrochureViewed = false;
            hasFlyoutBrochureStarted = false;
            window.sidenavBrochureUUID = crypto.randomUUID();
        });
    }
};

// ─── DOM Listeners ────────────────────────────────────────────────────────────

function bindConfiguratorBrochureFormEvents($container) {
    var $form = $container.find('#brochure-details-form');
    if (!$form.length) return;
    var startFired = false;
    $form.off('change.p2ConfigBrochure').on('change.p2ConfigBrochure', 'input, select, textarea', function () {
        if (!startFired) {
            startFired = true;
            dataLayer.push({
                event: 'custom.form',
                group: 'download_brochure',
                category: 'configurator',
                action: 'start',
                userRequestId: window.sidenavBrochureUUID || null,
                data: window._configBrochureData,
                models: window._configBrochureModels
            });
        }
        var fieldName = $(this).attr('name') || $(this).attr('id') || '';
        dataLayer.push({
            event: 'custom.form',
            group: 'download_brochure',
            category: 'configurator',
            action: 'interaction',
            field_name: fieldName,
            field_value: analyticsHelper.getPIISafeValue(fieldName, $(this).val()),
            userRequestId: window.sidenavBrochureUUID || null,
            data: window._configBrochureData,
            models: window._configBrochureModels
        });
    });
}

function init() {
    $('body').off('shown.bs.modal.brochure').on('shown.bs.modal.brochure', '#download-brochure-modal', function () {
        bindConfiguratorBrochureFormEvents($(this));
    });
    $('body').off('shown.bs.offcanvas.brochure').on('shown.bs.offcanvas.brochure', '#download-brochure-offcanvas', function () {
        bindConfiguratorBrochureFormEvents($(this));
    });
    $('body').off('click.brochureSidebar').on('click.brochureSidebar', '#sidebar-download-brochure', function () {
        $('body').trigger('gtm:event', { callback: 'sidebarDownloadBrochure', data: $(this) });
    });
    $('body').off('click.brochureSelectModel').on('click.brochureSelectModel', '#sidebar-select-model, .sidebar__brochure__select-car__toggle .car-model-img', function () {
        $('body').trigger('gtm:event', { callback: 'sidebarSelectAModel', data: $(this) });
    });
    $('body').off('click.brochureConfirmModel').on('click.brochureConfirmModel', '#brochure-select-model-confirm', function () {
        $('body').trigger('gtm:event', { callback: 'sidebarSelectedModel', data: $(this) });
    });
    $('body').off('click.brochureUserDetails').on('click.brochureUserDetails', '#brochure-submit-user-details', function () {
        $('body').trigger('gtm:event', { callback: 'submitUserDetails', data: $(this) });
    });
    $('body').off('download.brochure.afterLead.success.gtm').on('download.brochure.afterLead.success.gtm', function (e, response) {
        if (response && !response.error) {
            $('body').trigger('gtm:event', { callback: 'downloadBrochure', data: $('#brochure-details-form') });
        }
    });
}

module.exports = { init: init, events: events };
